import { requestOperation } from '../../../api/client';

export type NotificationListParams = { limit?: number; page?: number; _ts?: number };

export const notificationApi = {
  list: (params?: NotificationListParams) =>
    requestOperation('GET /api/v1/notifications', { query: params }),
  markRead: (id: string) =>
    requestOperation('PATCH /api/v1/notifications/{id}/read', { path: { id } }),
  markAllRead: () =>
    requestOperation('PATCH /api/v1/notifications/read-all'),
  markAllReadPost: () =>
    requestOperation('POST /api/v1/notifications/read-all'),
  clearAll: () =>
    requestOperation('DELETE /api/v1/notifications/clear-all'),
};
